import { useRoleAnnouncementStore } from "../store/role-announcement.store";

/**
 * A polite live region that reads out "Switched to <role>" after this tab
 * switches role. Mounted once, by the app layout.
 */
export function RoleSwitchAnnouncer(): React.JSX.Element {
	const message = useRoleAnnouncementStore((state) => state.message);
	return (
		<div role="status" aria-live="polite" className="sr-only">
			{message}
		</div>
	);
}
